module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAIVBMVEUAAABZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGp1pZ+wAAAACnRSTlMAGde/DsfdzDEQX3jgAwAAADBJREFUCNdjYGAQbmBgYNQyYGAQWj4ByAhhYBBb6sDAYLWQAchaDGSBxMCyYHVgHQDfLQg8vEFUJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_prev2.png
// module id = /26B
// module chunks = 9